<template>
  <Modal v-model="visible" :title="title" width="560" :mask-closable="false" transfer>
    <Form :label-width="90" :show-message="false" label-position="right">
      <template v-if="single">
        <Form-item label="外教">
          <span>{{ tchText(single) }}</span>
        </Form-item>
        <Form-item label="课节">
          <span v-if="single.manual">手动</span>
          <span v-else>{{ single.lessonDate || '' }} {{ single.beginTime || '' }}</span>
          <span class="muted">{{ singleMeta(single) }}</span>
        </Form-item>
        <Form-item label="异动类型">
          <Tag :color="typeColor(single.type)">{{ typeText(single.type) }}</Tag>
          <span v-if="!single.manual" class="muted">原因：{{ single.reason || '未填写' }}</span>
        </Form-item>
        <Form-item v-if="single.handled" label="原跟进">
          <span>{{ resultText(single.result) }}</span>
          <span class="muted">{{ single.handledBy || '' }} {{ single.handledAt || '' }}（提交后覆盖）</span>
        </Form-item>
      </template>
      <Form-item v-else label="涉及">
        <div>共 {{ lessons.length }} 节课 · {{ teacherNames }}</div>
      </Form-item>
      <Form-item :label="single ? '跟进结果' : '统一结果'" required>
        <Select v-model="form.result" transfer style="width: 240px;">
          <Option v-for="(item, code) in resultDict" :key="code" :value="code">{{ item.text }}</Option>
        </Select>
      </Form-item>
      <Form-item :label="single ? '跟进备注' : '统一备注'">
        <Input v-model="form.note" type="textarea" :rows="3" :maxlength="1000"
               :placeholder="single ? '沟通内容、后续措施、是否影响全勤资格等' : '将写入每一条记录'"></Input>
      </Form-item>
    </Form>
    <div slot="footer">
      <Button @click="visible = false">取消</Button>
      <Button type="primary" :loading="saving" @click="submit">{{ single ? '提交跟进' : '确认批量跟进' }}</Button>
    </div>
  </Modal>
</template>
<script>
import { API_PREFIX, FOLLOWUP_TYPE, FOLLOWUP_RESULT, FOLLOWUP_RESULT_OPTIONS, codeText, codeColor, tchLabel } from '../constants'
export default {
  name: 'FollowupHandleModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    // 每项需带 lessonId、type、tchId、lessonDate，可带 tchName 等展示字段
    lessons: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data () {
    return {
      visible: false,
      saving: false,
      resultDict: FOLLOWUP_RESULT_OPTIONS,
      form: {
        result: 'NORMAL_CLASS',
        note: ''
      }
    }
  },
  computed: {
    single () {
      return this.lessons.length === 1 ? this.lessons[0] : null
    },
    title () {
      if (this.single) {
        return '出勤跟进 · ' + tchLabel(this.single)
      }
      return '批量跟进 ' + this.lessons.length + ' 节课'
    },
    teacherNames () {
      let seen = {}
      let names = []
      this.lessons.forEach(function (l) {
        let n = tchLabel(l)
        if (n && !seen[n]) {
          seen[n] = 1
          names.push(n)
        }
      })
      return names.join('、')
    }
  },
  watch: {
    value (val) {
      this.visible = val
      if (val) {
        let s = this.single
        let next = 'NORMAL_CLASS'
        if (s && s.handled && s.result && FOLLOWUP_RESULT_OPTIONS[s.result]) {
          next = s.result
        }
        this.form = {
          result: next,
          note: s && s.handled ? (s.note || '') : ''
        }
      }
    },
    visible (val) {
      if (val === false) {
        this.$emit('on-close')
      }
    }
  },
  methods: {
    tchText (l) {
      return tchLabel(l) + '（ID ' + l.tchId + '）'
    },
    singleMeta (l) {
      if (!l) return ''
      if (l.manual) return '无学生'
      if (l.type === 'LEAVE') return '请假单 ' + l.lessonId
      return '课节 ' + l.lessonId + ' · 学员 ' + (l.studentName || l.uid || '—')
    },
    typeText (code) {
      return codeText(FOLLOWUP_TYPE, code)
    },
    typeColor (code) {
      return codeColor(FOLLOWUP_TYPE, code)
    },
    resultText (code) {
      return codeText(FOLLOWUP_RESULT, code) || '—'
    },
    submit () {
      let self = this
      if (!self.lessons.length) {
        return
      }
      if (!self.form.result) {
        self.$Message.warning('请选择跟进结果')
        return
      }
      let items = self.lessons.map(function (l) {
        let item = { type: l.type, tchId: l.tchId, date: l.lessonDate }
        if (l.lessonId != null && l.lessonId !== '') {
          item.lessonId = l.lessonId
        }
        if (l.manualId != null && l.manualId !== '') {
          item.manualId = l.manualId
        }
        return item
      })
      self.saving = true
      self.$http.post(API_PREFIX + '/followup/handle', {
        items: JSON.stringify(items),
        result: self.form.result,
        note: self.form.note
      }).then(function (res) {
        if (res && res.status === 'ok') {
          let n = typeof res.data === 'number' ? res.data : items.length
          self.$Message.success('已跟进 ' + n + ' 条')
          self.visible = false
          self.$root.$emit('hr-badges-refresh')
          self.$emit('on-success')
        }
      }).finally(function () {
        self.saving = false
      })
    }
  }
}
</script>
<style scoped lang="less">
.muted {
  margin-left: 6px;
  color: #8B93A7;
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// FollowupHandleModal.vue?09bcc117